import { useI18n as useVueI18n } from 'vue-i18n'

import type { MessageKey } from './en'

export type { MessageKey }

type TranslateValues = Record<string, unknown>

export function useI18n() {
  const i18n = useVueI18n()

  function t(key: MessageKey, values?: TranslateValues | number): string {
    if (values === undefined) {
      return i18n.t(key)
    }
    if (typeof values === 'number') {
      return i18n.t(key, values)
    }
    return i18n.t(key, values)
  }

  return { ...i18n, t }
}
